export default "__VITE_ASSET__CinjmW$S__"